import { useMutation } from '@tanstack/react-query'
import MarketplaceService from 'src/services/MarketplaceService'

const useOfferTracking = () => {
  const mutation = useMutation({
    mutationFn: ({ offerId, eventData }) =>
      MarketplaceService.recordOfferTrackingEvent(offerId, eventData)
  })

  const trackEvent = async (offerId, type, onSuccess, onError) => {
    if (!offerId) {
      if (onError) onError(new Error('Brak ID oferty'))
      return
    }

    const eventData = { type }

    try {
      const result = await mutation.mutateAsync({
        offerId,
        eventData
      })

      if (onSuccess) onSuccess(result)
      return result
    } catch (error) {
      if (onError) onError(error)
      throw error
    }
  }

  return {
    trackEvent,
    isLoading: mutation.isLoading,
    isError: mutation.isError,
    error: mutation.error
  }
}

export default useOfferTracking
